import * as ActionTypes from 'src/state/action-types';

export interface ISubscriptionState {
  id: string;
  active: boolean;
  state: 'active' | 'trial' | 'inactive' | 'canceled';
  display: string;
  next: string;
  begin: string;
  intervalUnit: string;
  nextChargeTotalDisplay: string;
  nextChargeDate: string;
  endDisplay: string;
  trial_since: number;
  displayInterval: 'monthly' | 'yearly';
  loading: boolean;
  errorCode?: string;
  paymentProvider: 'fastspring' | 'stripe' | null;
}

export const initialState: ISubscriptionState = {
  id: '',
  active: false,
  state: 'trial',
  display: '',
  next: '',
  begin: '',
  intervalUnit: '',
  nextChargeTotalDisplay: '',
  nextChargeDate: '',
  endDisplay: '',
  trial_since: 0,
  displayInterval: 'monthly',
  loading: false,
  errorCode: undefined,
  paymentProvider: null,
};

export default function subscriptionReducer(
  state: ISubscriptionState = initialState,
  action: ActionTypes.ActionTypes
): ISubscriptionState {
  switch (action.type) {
    case ActionTypes.SUBSCRIPTION_TOGGLE_INTERVAL:
      return {
        ...state,
        displayInterval: state.displayInterval === 'monthly' ? 'yearly' : 'monthly',
      };
    case ActionTypes.AUTH_GETSESSION_SUCCESS:
      return {
        ...state,
        ...action.payload.user.subscription,
      };

    case ActionTypes.SUBSCRIPTION_CANCEL_SUCCESS:
    case ActionTypes.SUBSCRIPTION_RESUME_SUCCESS:
    case ActionTypes.SUBSCRIPTION_GET_SUCCESS:
      return {
        ...state,
        ...action.payload.subscription,
      };

    case ActionTypes.SUBSCRIPTION_UNLINK_REQUEST:
    case ActionTypes.SUBSCRIPTION_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        errorCode: undefined,
      };

    case ActionTypes.SUBSCRIPTION_UNLINK_FAILURE:
    case ActionTypes.SUBSCRIPTION_LINK_FAILURE:
      return {
        ...state,
        loading: false,
        errorCode: action.errorCode,
      };

    case ActionTypes.SUBSCRIPTION_UNLINK_SUCCESS:
    case ActionTypes.SUBSCRIPTION_LINK_SUCCESS:
      return initialState;

    case ActionTypes.UI_RESET_ERRORS:
      return {
        ...state,
        loading: false,
        errorCode: undefined,
      };

    case ActionTypes.AUTH_LOGOUT_REQUEST:
    case ActionTypes.USER_DELETE_ACCOUNT_SUCCESS:
      return initialState;

    default:
      return state;
  }
}
